/* ==========================================================================
   VISOTALE WIZARD v9 — 5 adım: talimat / foto+kvkk / tablo seç / önizleme / sepet
   ========================================================================== */
(function () {
  'use strict';

  /* ---------- sabitler ---------- */
  // NOT: API_URL'i Railway deploy'undan aldığın gerçek domainle değiştir.
  var API_URL       = 'https://visotale-backend-production.up.railway.app/create-preview-job';
  var JOB_STATUS_URL = 'https://visotale-backend-production.up.railway.app/job-status/';
  var CLD_URL    = 'https://api.cloudinary.com/v1_1/dfclxpzlo/image/upload';
  var CLD_PRESET = 'visotale_uploads';
  var CLD_FOLDER = 'visotale-photos';
  var MAX_GEN    = 2;
  var POLL_INTERVAL_MS = 2000;
  var FAST_PATH_WINDOW_MS = 25000; // bu süre içinde bitmezse "mailine gönderiyoruz" ekranına geç
  var FAKE_MS    = 22000; // sahte ilerleme çubuğu, gerçek hızlı yol penceresine yakın
  var TOTAL_STEPS = 5;

  var PAINTINGS = [
    {
      key: 'sakayik_buketi',
      name: 'Barok Şakayık Buketi',
      sub: 'Hollanda Altın Çağı natürmortu',
      img: ''
    }
  ];

  var PRICE = {
    digital: 500,
    unframed: { 40: 1500, 50: 1800, 60: 2300, 80: 3200, 100: 4400 },
    framed:   { 40: 2300, 50: 3200, 60: 3400, 80: 5490, 100: 7490 }
  };
  var FORMAT_NAME = { digital: 'Dijital', unframed: 'Çerçevesiz Kanvas', framed: 'Çerçeveli Kanvas' };

  /* ---------- dom yardımcı ---------- */
  function q(sel, root) { return (root || document).querySelector(sel); }
  function qa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  var root = q('[data-wz-root]');
  if (!root) return;

  var dom = {
    overlay:    q('[data-wz-overlay]', root),
    stepdots:   qa('[data-wz-stepdot]', root),
    panels:     qa('[data-wz-panel]', root),
    close:      q('[data-wz-close]', root),
    back:       q('[data-wz-back]', root),
    backLabel:  q('[data-wz-back-label]', root),
    next:       q('[data-wz-next]', root),
    nextLabel:  q('[data-wz-next-label]', root),
    addcart:    q('[data-wz-addcart]', root),
    addcartLabel: q('[data-wz-addcart-label]', root),
    foot:       q('.vt-wz-foot', root),
    // adım 2 — foto + crop + kvkk
    drop:       q('[data-wz-drop]', root),
    input:      q('[data-wz-input]', root),
    crop:       q('[data-wz-crop]', root),
    cropArea:   q('[data-wz-crop-area]', root),
    cropImg:    q('[data-wz-crop-img]', root),
    cropBox:    q('[data-wz-crop-box]', root),
    cropReset:  q('[data-wz-crop-reset]', root),
    consent:    q('[data-wz-consent]', root),
    // adım 3 — tablo seç
    paintingList: q('[data-wz-paintinglist]', root),
    strengthBtns: qa('[data-wz-strength]', root),
    emailInput: q('[data-wz-email]', root),
    // adım 4 — üretim + önizleme (tek panel, iki görünüm)
    genView:    q('[data-wz-gen-view]', root),
    resultView: q('[data-wz-result-view]', root),
    emailView:  q('[data-wz-email-view]', root),
    emailShown: q('[data-wz-email-shown]', root),
    loadImg:    q('[data-wz-load-img]', root),
    progress:   q('[data-wz-progress]', root),
    phases:     qa('[data-wz-phase]', root),
    fail:       q('[data-wz-fail]', root),
    failText:   q('[data-wz-fail-text]', root),
    retry:      q('[data-wz-retry]', root),
    resultImg:  q('[data-wz-result-img]', root),
    restyle:    q('[data-wz-restyle]', root),
    quota:      q('[data-wz-quota]', root),
    // adım 5 — format + sepet
    formatBtns: qa('[data-wz-format]', root),
    formatPanes:qa('[data-wz-format-pane]', root),
    sizeBtns:   qa('[data-wz-size]', root),
    sumStyle:   q('[data-wz-sum-style]', root),
    sumDetail:  q('[data-wz-sum-detail]', root),
    sumDetailRow: q('[data-wz-sum-detail-row]', root),
    sumPrice:   q('[data-wz-sum-price]', root)
  };

  /* ---------- state ---------- */
  var st = {
    step: 1,
    file: null,
    cloudUrl: null,
    paintingKey: null, paintingName: null,
    strength: 'orta',
    email: '',
    previewUrl: null,
    genCount: 0,
    format: 'unframed', size: 50
  };

  var fakeTimer = null;
  var pollTimer = null;

  /* ---------- aç / kapat ---------- */
  function openWz() {
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeWz() {
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    stopFake();
    stopPoll();
  }
  qa('[data-wizard-open]').forEach(function (b) { b.addEventListener('click', openWz); });
  dom.close.addEventListener('click', closeWz);
  dom.overlay.addEventListener('click', closeWz);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-open')) closeWz();
  });

  /* ---------- adım yönetimi ---------- */
  function setStep(n) {
    st.step = n;
    dom.panels.forEach(function (p) { p.classList.toggle('is-active', +p.dataset.wzPanel === n); });
    dom.stepdots.forEach(function (d) {
      var v = +d.dataset.wzStepdot;
      d.classList.toggle('is-active', v === n);
      d.classList.toggle('is-done', v < n);
    });

    // footer: adım 4'te üretim sırasında ya da "mailine gönderiyoruz" ekranında geri/devam gizli
    var isWaiting = (n === 4 && !st.previewUrl);
    dom.back.style.display = isWaiting ? 'none' : '';
    dom.next.hidden    = isWaiting || (n === TOTAL_STEPS);
    dom.addcart.hidden = (n !== TOTAL_STEPS);
    dom.backLabel.textContent = (n === 1) ? 'Vazgeç' : 'Geri';
    if (dom.nextLabel) dom.nextLabel.textContent = (n === 3) ? 'Önizleme İste' : 'Devam et';

    syncNext();

    if (n === 3) buildPaintingList();
    if (n === 4 && !st.previewUrl) runGeneration();
    if (n === 4 && st.previewUrl) showResult();
    if (n === 5) fillSummary();
  }

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function syncNext() {
    var ok = false;
    if (st.step === 1) ok = true; // bilgilendirme adımı
    else if (st.step === 2) ok = (!dom.crop.hidden || !!st.file) && !!(dom.consent && dom.consent.checked);
    else if (st.step === 3) ok = !!st.paintingKey && EMAIL_RE.test(st.email);
    else if (st.step === 4) ok = !!st.previewUrl;
    else if (st.step === 5) ok = true;
    dom.next.disabled = !ok;
  }

  if (dom.emailInput) {
    dom.emailInput.addEventListener('input', function () {
      st.email = dom.emailInput.value.trim();
      syncNext();
    });
  }

  dom.next.addEventListener('click', function () {
    if (st.step === 2 && !dom.crop.hidden) {
      applyCrop(function () { setStep(3); });
      return;
    }
    if (st.step < TOTAL_STEPS) setStep(st.step + 1);
  });

  dom.back.addEventListener('click', function () {
    if (st.step === 1) { closeWz(); return; }
    setStep(st.step - 1);
  });

  if (dom.consent) {
    dom.consent.addEventListener('change', syncNext);
  }

  /* ==========================================================================
     ADIM 2 — upload + crop (sürükle + köşelerden boyutlandır) + KVKK
     ========================================================================== */
  dom.drop.addEventListener('click', function () { dom.input.click(); });
  dom.drop.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); dom.input.click(); }
  });
  dom.drop.addEventListener('dragover', function (e) { e.preventDefault(); dom.drop.classList.add('is-over'); });
  dom.drop.addEventListener('dragleave', function () { dom.drop.classList.remove('is-over'); });
  dom.drop.addEventListener('drop', function (e) {
    e.preventDefault(); dom.drop.classList.remove('is-over');
    if (e.dataTransfer.files[0]) acceptFile(e.dataTransfer.files[0]);
  });
  dom.input.addEventListener('change', function (e) {
    if (e.target.files[0]) acceptFile(e.target.files[0]);
    e.target.value = '';
  });
  dom.cropReset.addEventListener('click', resetToDrop);

  function resetToDrop() {
    dom.crop.hidden = true;
    dom.drop.hidden = false;
    st.file = null; st.cloudUrl = null;
    syncNext();
  }

  function acceptFile(file) {
    if (!/^image\/(jpe?g|png|webp)$/i.test(file.type)) { alert('Lütfen JPG, PNG veya WebP seç.'); return; }
    if (file.size > 20 * 1024 * 1024) { alert('Dosya 20MB sınırını aşıyor.'); return; }
    var reader = new FileReader();
    reader.onload = function (e) {
      dom.drop.hidden = true;
      dom.crop.hidden = false;
      dom.cropImg.onload = function () { initCrop(); syncNext(); };
      dom.cropImg.src = e.target.result;
    };
    reader.readAsDataURL(file);
  }

  /* ---- crop motoru: sürükle + köşelerden boyutlandır, kare sabit ---- */
  var cz = { x: 0, y: 0, s: 0, w: 0, h: 0 };

  function initCrop() {
    // önceki fotoğraftan kalan sabit boyutu temizle ki yeni görsel
    // doğal (max-width/max-height'e göre) boyutuyla ölçülsün
    dom.cropArea.style.width = '';
    dom.cropArea.style.height = '';
    var w = dom.cropImg.clientWidth;
    var h = dom.cropImg.clientHeight;
    // vt-wz-crop-area ortalayan bir flex kutusu; konteyner görselden
    // genişse (dikey/kare fotoğraflarda olur) kırpma kutusunun (0,0)
    // referansı görselin gerçek sol-üst köşesinden kayar ve kutu sağa/
    // alta tam gidemez. Konteyneri görselin gerçek boyutuna kilitleyip
    // bu kaymayı ortadan kaldırıyoruz.
    dom.cropArea.style.width = w + 'px';
    dom.cropArea.style.height = h + 'px';
    var s = Math.round(Math.min(w, h) * 0.82);
    cz = { x: Math.round((w - s) / 2), y: Math.round((h - s) / 2), s: s, w: w, h: h };
    paintCrop();
  }

  function paintCrop() {
    dom.cropBox.style.left   = cz.x + 'px';
    dom.cropBox.style.top    = cz.y + 'px';
    dom.cropBox.style.width  = cz.s + 'px';
    dom.cropBox.style.height = cz.s + 'px';
  }

  var gesture = null;
  dom.cropBox.addEventListener('mousedown', startMove);
  dom.cropBox.addEventListener('touchstart', startMove, { passive: false });
  qa('[data-wz-grip]', root).forEach(function (g) {
    g.addEventListener('mousedown', function (e) { startResize(e, g.dataset.wzGrip); });
    g.addEventListener('touchstart', function (e) { startResize(e, g.dataset.wzGrip); }, { passive: false });
  });

  function ptOf(e) { return e.touches ? e.touches[0] : e; }

  function startMove(e) {
    if (e.target.hasAttribute('data-wz-grip')) return;
    e.preventDefault(); e.stopPropagation();
    var p = ptOf(e);
    gesture = { mode: 'move', px: p.clientX, py: p.clientY, x: cz.x, y: cz.y };
    bindGesture();
  }
  function startResize(e, corner) {
    e.preventDefault(); e.stopPropagation();
    var p = ptOf(e);
    gesture = { mode: 'resize', corner: corner, px: p.clientX, py: p.clientY, x: cz.x, y: cz.y, s: cz.s };
    bindGesture();
  }
  function bindGesture() {
    document.addEventListener('mousemove', onGesture);
    document.addEventListener('mouseup', endGesture);
    document.addEventListener('touchmove', onGesture, { passive: false });
    document.addEventListener('touchend', endGesture);
  }
  function endGesture() {
    gesture = null;
    document.removeEventListener('mousemove', onGesture);
    document.removeEventListener('mouseup', endGesture);
    document.removeEventListener('touchmove', onGesture);
    document.removeEventListener('touchend', endGesture);
  }
  function clamp(v, lo, hi) { return v < lo ? lo : (v > hi ? hi : v); }

  function onGesture(e) {
    if (!gesture) return;
    if (e.cancelable) e.preventDefault();
    var p = ptOf(e);
    var dx = p.clientX - gesture.px;
    var dy = p.clientY - gesture.py;

    if (gesture.mode === 'move') {
      cz.x = clamp(gesture.x + dx, 0, cz.w - cz.s);
      cz.y = clamp(gesture.y + dy, 0, cz.h - cz.s);
    } else {
      var MIN = 60;
      var x0 = gesture.x, y0 = gesture.y, s0 = gesture.s;
      var right = x0 + s0, bottom = y0 + s0;
      var ns, nx, ny;

      if (gesture.corner === 'se') {
        ns = clamp(s0 + Math.max(dx, dy), MIN, Math.min(cz.w - x0, cz.h - y0));
        nx = x0; ny = y0;
      } else if (gesture.corner === 'nw') {
        ns = clamp(s0 - Math.min(dx, dy), MIN, Math.min(right, bottom));
        nx = right - ns; ny = bottom - ns;
      } else if (gesture.corner === 'ne') {
        ns = clamp(s0 + Math.max(dx, -dy), MIN, Math.min(cz.w - x0, bottom));
        nx = x0; ny = bottom - ns;
      } else { // sw
        ns = clamp(s0 + Math.max(-dx, dy), MIN, Math.min(right, cz.h - y0));
        nx = right - ns; ny = y0;
      }
      cz.s = ns;
      cz.x = clamp(nx, 0, cz.w - ns);
      cz.y = clamp(ny, 0, cz.h - ns);
    }
    paintCrop();
  }

  function applyCrop(done) {
    var img = dom.cropImg;
    var sx = img.naturalWidth / cz.w;
    var sy = img.naturalHeight / cz.h;
    var canvas = document.createElement('canvas');
    canvas.width = 1024; canvas.height = 1024;
    var ctx = canvas.getContext('2d');
    ctx.drawImage(
      img,
      cz.x * sx, cz.y * sy, cz.s * sx, cz.s * sy,
      0, 0, 1024, 1024
    );
    canvas.toBlob(function (blob) {
      st.file = new File([blob], 'visotale.jpg', { type: 'image/jpeg' });
      uploadCloud(st.file);
      if (done) done();
    }, 'image/jpeg', 0.92);
  }

  function uploadCloud(file) {
    st.cloudUrl = null;
    var fd = new FormData();
    fd.append('file', file);
    fd.append('upload_preset', CLD_PRESET);
    fd.append('folder', CLD_FOLDER);
    fetch(CLD_URL, { method: 'POST', body: fd })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (d) { st.cloudUrl = d.secure_url; })
      .catch(function () { /* sessiz fallback — dosya direkt API'ye gidecek */ });
  }

  /* ==========================================================================
     ADIM 3 — tablo seçimi (düz liste, 4 tablo)
     ========================================================================== */
  function buildPaintingList() {
    dom.paintingList.innerHTML = PAINTINGS.map(function (p) {
      var thumb = p.img
        ? '<img src="' + p.img + '" alt="' + p.name + '" loading="lazy">'
        : '';
      return '<button type="button" class="vt-wz-row" data-wz-painting="' + p.key + '">'
        + '<span class="vt-wz-row-thumb">' + thumb + '</span>'
        + '<span class="vt-wz-row-text">'
        + '<span class="vt-wz-row-name">' + p.name + '</span>'
        + '<span class="vt-wz-row-sub">' + p.sub + '</span>'
        + '</span>'
        + '<svg class="vt-wz-row-arrow" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M6 4l4 4-4 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>'
        + '</button>';
    }).join('');
    qa('[data-wz-painting]', dom.paintingList).forEach(function (b) {
      b.addEventListener('click', function () { selectPainting(b.dataset.wzPainting); });
    });
    // tek stil varsa otomatik seç
    if (PAINTINGS.length === 1 && !st.paintingKey) { selectPainting(PAINTINGS[0].key); }
    // mevcut seçim varsa vurgula
    if (st.paintingKey) {
      qa('[data-wz-painting]', dom.paintingList).forEach(function (b) {
        b.classList.toggle('is-active', b.dataset.wzPainting === st.paintingKey);
      });
    }
  }

  function selectPainting(key) {
    var p = null;
    PAINTINGS.forEach(function (x) { if (x.key === key) p = x; });
    if (!p) return;
    st.paintingKey = p.key;
    st.paintingName = p.name;
    qa('[data-wz-painting]', dom.paintingList).forEach(function (b) {
      b.classList.toggle('is-active', b.dataset.wzPainting === key);
    });
    syncNext();
  }


  /* ==========================================================================
     ADIM 4 — üretim + önizleme (tek panel, üç görünüm: üretim/sonuç/mail)
     ========================================================================== */
  function stopFake() { if (fakeTimer) { clearInterval(fakeTimer); fakeTimer = null; } }
  function stopPoll() { if (pollTimer) { clearInterval(pollTimer); pollTimer = null; } }

  function setPhase(active, done) {
    dom.phases.forEach(function (p) {
      var v = +p.dataset.wzPhase;
      p.classList.toggle('is-active', v === active);
      p.classList.toggle('is-done', done.indexOf(v) !== -1);
    });
  }

  function showGenerating() {
    dom.genView.hidden = false;
    dom.resultView.hidden = true;
    if (dom.emailView) dom.emailView.hidden = true;
  }
  function showResult() {
    dom.genView.hidden = true;
    dom.resultView.hidden = false;
    if (dom.emailView) dom.emailView.hidden = true;
    dom.resultImg.src = st.previewUrl || '';
    if (st.genCount >= MAX_GEN) {
      dom.quota.textContent = 'Üretim hakkın doldu';
      dom.restyle.style.display = 'none';
    } else {
      dom.quota.textContent = st.genCount + '/' + MAX_GEN + ' deneme kullanıldı';
      dom.restyle.style.display = '';
    }
    dom.back.style.display = '';
    dom.next.hidden = false;
    syncNext();
  }
  function showEmailSent() {
    dom.genView.hidden = true;
    dom.resultView.hidden = true;
    if (dom.emailView) dom.emailView.hidden = false;
    if (dom.emailShown) dom.emailShown.textContent = st.email;
    dom.back.style.display = 'none';
    dom.next.hidden = true;
  }

  function runGeneration() {
    showGenerating();
    dom.fail.hidden = true;
    dom.back.style.display = 'none';
    dom.next.hidden = true;

    var painting = null;
    PAINTINGS.forEach(function (p) { if (p.key === st.paintingKey) painting = p; });
    if (painting && painting.img) dom.loadImg.src = painting.img;

    dom.progress.style.width = '0%';
    setPhase(1, []);

    var t = 0;
    stopFake();
    fakeTimer = setInterval(function () {
      t += 100;
      dom.progress.style.width = Math.min(95, (t / FAKE_MS) * 95) + '%';
      if (t === 6000)  setPhase(2, [1]);
      if (t === 13000) setPhase(3, [1, 2]);
    }, 100);

    var fd = new FormData();
    if (st.cloudUrl) fd.append('image_url', st.cloudUrl);
    else if (st.file) fd.append('file', st.file, 'visotale.jpg');
    fd.append('painting_key', st.paintingKey);
    fd.append('strength', st.strength);
    fd.append('email', st.email);

    function handleFailure(msg, debugData) {
      stopFake();
      stopPoll();
      if (debugData) {
        console.log('%c[Visotale] Üretim BAŞARISIZ oldu — hataya kadar geçen süreler', 'font-weight:bold;color:#b3403f;');
        console.table(debugData.timings_s);
        if (debugData.conditioning_url) console.log('2) Conditioning görseli:', debugData.conditioning_url);
      }
      dom.failText.textContent = msg || 'Üretim başarısız oldu. Lütfen tekrar dene.';
      dom.fail.hidden = false;
      dom.progress.style.width = '0%';
      setPhase(1, []);
    }

    function handleSuccess(previewUrl, debugData, elapsedS) {
      var pre = new Image();
      pre.onload = pre.onerror = function () {
        stopFake();
        stopPoll();
        dom.progress.style.width = '100%';
        setPhase(0, [1, 2, 3]);
        st.previewUrl = previewUrl;
        st.genCount++;
        if (debugData) {
          console.log('%c[Visotale] Üretim detayları', 'font-weight:bold;color:#225033;');
          console.log('Toplam süre:', elapsedS + 's');
          console.table(debugData.timings_s);
          console.log('2) Conditioning görseli:', debugData.conditioning_url);
          console.log('3) fal.ai ham sonucu:', debugData.raw_result_url);
          console.log('4) Final önizleme:', previewUrl);
        }
        setTimeout(function () { showResult(); }, 350);
      };
      pre.src = previewUrl;
    }

    fetch(API_URL, { method: 'POST', body: fd })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok || !res.data.ok || !res.data.job_id) {
          handleFailure((res.data && res.data.error) || 'İstek gönderilemedi.');
          return;
        }
        var jobId = res.data.job_id;
        var startedAt = Date.now();

        stopPoll();
        pollTimer = setInterval(function () {
          var elapsedMs = Date.now() - startedAt;

          fetch(JOB_STATUS_URL + jobId)
            .then(function (r) { return r.json(); })
            .then(function (s) {
              if (s.status === 'done') {
                handleSuccess(s.preview_url, s.debug, s.elapsed_s);
              } else if (s.status === 'error') {
                handleFailure(s.error, s.debug);
              } else if (elapsedMs >= FAST_PATH_WINDOW_MS) {
                // yeterince bekledik, hâlâ bitmedi — arka planda devam ediyor,
                // müşteriyi burada bekletmeyip mail ekranına geçiyoruz
                stopFake();
                stopPoll();
                showEmailSent();
              }
              // aksi halde: hâlâ pending ve pencere dolmadı, poll devam eder
            })
            .catch(function () { /* geçici ağ hatası — bir sonraki polde tekrar dener */ });
        }, POLL_INTERVAL_MS);
      })
      .catch(function (err) {
        handleFailure((err && err.message) || 'İstek gönderilemedi.');
      });
  }

  dom.retry.addEventListener('click', function () { dom.fail.hidden = true; runGeneration(); });

  dom.restyle.addEventListener('click', function () {
    if (st.genCount >= MAX_GEN) return;
    st.previewUrl = null;
    setStep(3);
  });

  /* ==========================================================================
     ADIM 5 — format + sepet
     ========================================================================== */
  dom.formatBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      dom.formatBtns.forEach(function (x) { x.classList.remove('is-active'); });
      b.classList.add('is-active');
      st.format = b.dataset.wzFormat;
      dom.formatPanes.forEach(function (p) { p.hidden = (p.dataset.wzFormatPane !== st.format); });
      fillSummary();
    });
  });
  dom.sizeBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      // aynı boyut butonu iki panelde de var (çerçevesiz/çerçeveli) — ikisini de senkronla
      var size = b.dataset.wzSize;
      qa('[data-wz-size="' + size + '"]', root).forEach(function () {});
      dom.sizeBtns.forEach(function (x) { x.classList.toggle('is-active', x.dataset.wzSize === size); });
      st.size = +size;
      fillSummary();
    });
  });

  function fillSummary() {
    dom.sumStyle.textContent = st.paintingName || '—';
    var price;
    if (st.format === 'digital') {
      price = PRICE.digital;
      dom.sumDetailRow.style.display = 'none';
    } else {
      price = PRICE[st.format][st.size];
      dom.sumDetailRow.style.display = '';
      dom.sumDetail.textContent = st.size + '×' + st.size + ' cm · ' + FORMAT_NAME[st.format];
    }
    dom.sumPrice.textContent = price.toLocaleString('tr-TR') + '₺';
  }

  /* ---- variant eşleştirme ---- */
  var product = null;
  var pv = q('[data-product-variants]');
  if (pv) { try { product = JSON.parse(pv.textContent); } catch (e) {} }

  function matchVariant() {
    if (!product || !product.variants) return null;
    var norm = function (s) { return String(s || '').trim().toLowerCase().replace(/×/g, 'x').replace(/\s+/g, ' '); };
    var o1, o2;
    if (st.format === 'digital') { o1 = 'dijital'; o2 = 'jpg'; }
    else {
      o1 = st.size + 'x' + st.size;
      o2 = (st.format === 'framed') ? 'çerçeveli' : 'çerçevesiz';
    }
    var found = null;
    product.variants.forEach(function (v) {
      if (!found && norm(v.option1) === o1 && norm(v.option2) === o2) found = v;
    });
    if (!found) product.variants.forEach(function (v) { if (!found && v.available) found = v; });
    return found ? found.id : null;
  }

  dom.addcart.addEventListener('click', function () {
    if (dom.addcart.disabled) return;
    var vid = matchVariant();
    if (!vid) { cartError('Ürün varyantı bulunamadı, sayfayı yenile.'); return; }

    dom.addcart.disabled = true;
    var label = dom.addcartLabel ? dom.addcartLabel.textContent : 'Sepete ekle';
    if (dom.addcartLabel) dom.addcartLabel.textContent = 'Ekleniyor…';

    var props = {
      'Tablo': st.paintingName || '',
      'Format': FORMAT_NAME[st.format],
      '_preview_url': st.previewUrl || '',
      '_original_photo_url': st.cloudUrl || ''
    };
    if (st.format !== 'digital') {
      props['Boyut'] = st.size + '×' + st.size + ' cm';
    }

    var cartItems = [{ id: vid, quantity: 1, properties: props }];
    if (window.VisotaleBundle && window.VisotaleBundle.enabled && window.VisotaleBundle.variantId) {
      cartItems.push({ id: window.VisotaleBundle.variantId, quantity: 1 });
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: cartItems })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.d.description || res.d.message || 'Sepete eklenemedi.');
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        if (window.VisotaleCart) {
          if (window.VisotaleCart.updateCount) window.VisotaleCart.updateCount(cart.item_count);
          if (window.VisotaleCart.refreshDrawer) window.VisotaleCart.refreshDrawer();
        }
        qa('[data-cart-count]').forEach(function (c) { c.textContent = cart.item_count; });
        if (dom.addcartLabel) dom.addcartLabel.textContent = label;
        dom.addcart.disabled = false;
        closeWz();
        setTimeout(function () {
          if (window.VisotaleCart && window.VisotaleCart.openDrawer) window.VisotaleCart.openDrawer();
          else window.location.href = '/cart';
        }, 250);
      })
      .catch(function (err) {
        dom.addcart.disabled = false;
        if (dom.addcartLabel) dom.addcartLabel.textContent = label;
        cartError(err.message || 'Bir hata oluştu.');
      });
  });

  function cartError(msg) {
    var box = q('[data-wz-carterr]', root);
    if (!box) {
      box = document.createElement('div');
      box.className = 'vt-wz-carterr';
      box.setAttribute('data-wz-carterr', '');
      dom.foot.parentNode.insertBefore(box, dom.foot);
    }
    box.textContent = msg;
    setTimeout(function () { if (box.parentNode) box.parentNode.removeChild(box); }, 6000);
  }

  /* ---------- mailden dönüş: doğrudan sepet adımına atla ---------- */
  function resumeFromEmailIfNeeded() {
    var params = new URLSearchParams(window.location.search);
    var previewParam = params.get('vt_preview');
    var paintingParam = params.get('vt_tablo');
    if (!previewParam || !paintingParam) return false;

    var painting = null;
    PAINTINGS.forEach(function (p) { if (p.key === paintingParam) painting = p; });

    st.previewUrl = previewParam; // URLSearchParams zaten decode ediyor
    st.paintingKey = paintingParam;
    st.paintingName = painting ? painting.name : 'Tablon';

    openWz();
    setStep(5);
    return true;
  }

  /* ---------- init ---------- */
  if (!resumeFromEmailIfNeeded()) {
    setStep(1);
  }
})();
